import type React from "react";
import DateRangeSelector from "../../../components/DateRangeSelector";

interface Props {
  data: any;
  dataRange: string;
  fromDate: string;
  toDate: string;
  onDateRangeChange: (value: string) => void;
  onFromDateChange: (date: string) => void;
  onToDateChange: (date: string) => void;
}

const ProfitLossSummary: React.FC<Props> = ({
  data,
  dataRange,
  fromDate,
  toDate,
  onDateRangeChange,
  onFromDateChange,
  onToDateChange,
}) => {
  const metrics = [
    { label: "Total Income", value: data?.incomeAmount ?? "Rs. 0/-" },
    { label: "Total Expenses", value: data?.expenseAmount ?? "Rs. 0/-" },
    { label: "Profit / Loss", value: data?.profitLoss ?? "Rs. 0/-" },
    { label: "Status", value: data?.status ?? "N/A" },
  ];

  const getStatusColor = (status: string) => {
    if (status === "Profit") return "text-green-600";
    if (status === "Loss") return "text-red-600";
    return "text-gray-800";
  };

  return (
    <div className="bg-white rounded-lg shadow-sm p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold mb-4 text-gray-700">
          Profit & Loss Summary:{" "}
          {dataRange === "custom"
            ? `from ${fromDate} to ${toDate}`
            : `${dataRange}`}
        </h3>
        <DateRangeSelector
          preset="lab"
          compact
          dateRange={dataRange}
          fromDate={fromDate}
          toDate={toDate}
          onDateRangeChange={onDateRangeChange}
          onFromDateChange={onFromDateChange}
          onToDateChange={onToDateChange}
        />
      </div>
      <dl className="divide-y divide-gray-200">
        {metrics.map(item => (
          <div key={item.label} className="flex justify-between py-2">
            <dt className="text-sm font-medium text-gray-600">{item.label}</dt>
            <dd className={`text-sm font-bold text-right ${item.label === "Status" ? getStatusColor(item.value) : "text-gray-800"}`}>
              {item.value || "Rs. 0/-"}
            </dd>
          </div>
        ))}
      </dl>
    </div>
  );
};

export default ProfitLossSummary;
